export default __webpack_public_path__ + "static/media/bj_switch.34503c83.gif";